import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/solar-panel-repair")({
  head: () => ({
    meta: [
      { title: "Solar Panel Repair in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Solar panel and inverter repair across Southern California. Diagnose underperforming systems, replace failed components and restore full output." },
      { property: "og:title", content: "Solar Panel Repair in Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: "Get your solar system back to full production with local repair experts." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-panel-repair" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["solar-panel-repair"]} />,
});